import { ofType, Epic } from "redux-observable";
import { catchError, map, merge, mergeMap, of, takeUntil } from "rxjs";
import { selectAuthTokens } from "../../../../features/auth/selectors/auth.selector";
import { IAction } from "../../../../interface/action.interface";
import { IErrorDto } from "../../../../interface/dto/error.dto";
import { IRootState } from "../../../../redux/root.reducer";
import { getSublist } from "../../service/sublist.api";
import {
    SublistActionType,
    ISublistAction,
    sublistGetErrorAction,
    sublistGetSuccessAction,
    ISublistGetAction,
} from "./sublists.actions";

export const sublistEpic: Epic<IAction, IAction, IRootState> = (action$) =>
    merge(
        action$.pipe(
            ofType<ISublistAction, SublistActionType.SUBLIST_GET>(
                SublistActionType.SUBLIST_GET,
            ),
            mergeMap((action) =>
                getSublist(action.payload.listId, selectAuthTokens()).pipe(
                    takeUntil(
                        action$.pipe(
                            ofType<
                                ISublistGetAction,
                                SublistActionType.SUBLIST_GET
                            >(SublistActionType.SUBLIST_GET),
                        ),
                    ),
                    map((result) => sublistGetSuccessAction(result ?? [])),
                    catchError((error: IErrorDto) =>
                        of(sublistGetErrorAction(error.message)),
                    ),
                ),
            ),
        ),
    );
